import React, { Component } from "react";
import axios from "axios";
import defaults from "../constants/defaults";
import DealItem from "./DealItem";
import FooterNav from "./FooterNav";
import HeaderAO from "./OcationAds/HeaderAO";
import { NewBanner } from "./News/NewBanner";
import { RTBVideo } from "./RTBVideo";
import {RTBBanner} from "./RTBBanner";
import { RTBVideoBanner } from "./RTBVideoBanner";
import { Loading } from "./Loading";


export default class DealItems extends Component {
  state = {
    campaigns: [],
    rtb: null,
    avisos: {},
    logoURL: '',
    capturedPages: new Set(),
    campaignPageNumber: 0,
    isCampaignLoading: false,
    accessTimes: null,
    threshold: 0,
    errorMsg: "",
    band: null,
    survey_ids: [],
    defaultCampaign: {},
    token: false,
    showAds: {
      show: false,
      label: "",
      item_url: ""
    },
    USER: null,
    skip_seconds: 30,
    each_seconds: 30,
    bc_seconds: 10,
    gads_seconds: 10,
    wifiMinutes: 20,
    skip_podcast: 30,
    portal_label_return: 'Si, regresar',
    portal_label_access: 'No, Accesar WiFi',
    portal_show_timer: true,
    start_counter: false,
    forward_audio_podcast: 15,
    portal_label_home: '', 
    portal_label_wifigratis: '',
    show_popup: true,
    storeName: '',
    ghz_condition: false,
    fontParam: '',
    backgroundParam: '',
    fontColorParam: ''
  };

  componentDidMount = async () => {
    await this._getUser();
    await this._getCampaigns();
    //this.setAdGoogleTest();
   // await this.getInfoToken();
  };

  _getCampaigns = async () => {
    const { ap, deviceId, postBalance, test} = this.props;
    try {
      await this.setState({
        isCampaignLoading: true
      });
      
      let fields = {
        DeviceID: deviceId ? deviceId : defaults.DeviceID,
        AccessPointID: ap.ap_mac,
        LocationID: ap.ap_locationid
      };
      if(test) {
        fields = {
          DeviceID: '',
          AccessPointID: ap.ap_mac,
          LocationID: ap.ap_locationid
        }
      }
      const res = await axios.get("/campaigns", {
        params: fields
      });

      const show_ads = await axios.get("/show_ads");
      const { media } = res.data;
      this.setState({
        logoURL: media.logoURL,
        campaigns: media.campaigns,
        defaultCampaign: media.defaultCampaign,
        rtb: media.rtb,
        avisos: media.avisos,
        isCampaignLoading: false,
        showAds: show_ads.data,
        threshold: media.threshold,
        skip_seconds: media.skip_seconds,
        each_seconds: media.each_seconds,
        bc_seconds: media.bc_seconds,
        gads_seconds: media.gads_seconds,
        wifiMinutes: media.wifiMinutes,
        portal_label_return: media.portal_label_return,
        portal_label_access: media.portal_label_access,
        portal_show_timer: media.portal_show_timer,
        skip_podcast: media.skip_podcast,
        start_counter: media.start_counter,
        forward_audio_podcast: media.forward_audio_podcast,
        portal_label_home: media.portal_label_home, 
        portal_label_wifigratis: media.portal_label_wifigratis,
        show_popup: media.show_popup,
        storeName: media.storeName,
        ghz_condition: media.ghz_condition,
        fontColorParam: media.fontColorParam,
        fontParam: media.fontParam,
        backgroundParam: media.backgroundParam,
      });

  
    } catch (err) {
      this.setState({
        isCampaignLoading: false,
        errorMsg: "Campaign Request: " + err.message
      });
    }
  };

  _buildCampaignPages = campaigns => {
    let campaignPages = [];
    let campaignPage = [];
    const {band, threshold, USER} = this.state;

    for (let i = 0; i < campaigns.length; i++) {
      let c = campaigns[i];
      if(c.ghz5_only && band===2.4) {
        continue;
      } 
      if(USER) {
        if(!c.ghz5_only && USER.health < threshold ) {
          continue;
        }
      }
      campaignPage.push(c);
      if ((i + 1) % defaults.maxCampaigns === 0 || i === campaigns.length - 1) {
        campaignPages.push(campaignPage);
        campaignPage = [];
      }
    }
    return campaignPages;
  };

  _changePage = change => {
    const { campaignPageNumber } = this.state;
    this.setState({
      campaignPageNumber: campaignPageNumber + change
    });
  };

  _captureCampaignImpressions = async (CampaignIDs) => {
    const { ap, postBalance, test } = this.props;
    const {campaigns} = this.state;
    const urlString = window.location.href;
    const url = new URL(urlString);
    const DeviceID = url.searchParams.get("mac") || defaults.DeviceID;
    try {
      let ids = [];
      if(!test) {
        const fields = {
          AccessPointID: ap.ap_mac,
          LocationID: Number(ap.ap_locationid),
          DeviceID,
          CampaignIDs: CampaignIDs,
          MediaType: "banner"
        };
        const {data} = await axios.post("/impressions", { fields, batch: true });
        ids = data;
      }

      if(campaigns.length && campaigns.length > 1 && !test) {
        let campaign = {
          ...campaigns[0],
          ids: CampaignIDs,
        }
        await postBalance(campaign, "banner", ids);
      } else if(!test) {
        await postBalance(campaigns[0], "banner", ids);
      }
    } catch (err) {
      console.log(err);
    }
  };

  _capturePageImpression = campaignPage => {
    const { capturedPages, campaignPageNumber, rtb } = this.state;
    if (capturedPages.has(campaignPageNumber)) {
      return;
    } else {
      const CampaignIDs = campaignPage.map(campaign => campaign.CampaignID);
      this._captureCampaignImpressions(CampaignIDs);
      capturedPages.add(campaignPageNumber);
    }
  };

  _getUser = async () => {
    try {
      const urlString = window.location.href;
      const url = new URL(urlString);
      const { ap } = this.props;
      const DeviceID = url.searchParams.get("mac") || defaults.DeviceID;
      const fields = {
        DeviceID,
        DeviceType: navigator.userAgent,
        Registration_AP_ID: ap.ap_mac
      };
      const res = await axios.get("/users", {
         params: fields
      });
      const { AccessTimes, survey_ids } = res.data;
      const u = res.data;
      const band = Number(res.data.band);
      await this.setState({
        accessTimes: AccessTimes,
        USER: u,
        survey_ids: survey_ids ? survey_ids.split(",") : [],
        band: band ? band : 2.4,
       // user: red.data,
      });
    } catch (err) {
      this.setState({
        errorMsg: "User Request " + err.message
      });
    }
  };

  getInfoToken = async() => {
    try {
      const res = await axios.get("/token");
      if(res) {
        this.setState({
          token: true
        })
      } 
    } catch (error) {
      console.log(error);
    }
  }

  setAdGoogleTest = () => {
    let adsbygoogle = document.getElementsByClassName("adsbygoogle");
    (adsbygoogle =  window.adsbygoogle || []).push({});
  }

  render = () => {
    // @TODO: Handle loading state
    const {
      logoURL, campaigns, errorMsg, campaignPageNumber, accessTimes, band, survey_ids, 
      token, avisos, gads_seconds, showAds, defaultCampaign, threshold, USER, skip_seconds, 
      each_seconds, bc_seconds, rtb, wifiMinutes, portal_label_access, portal_label_return, portal_show_timer, 
      skip_podcast, start_counter, forward_audio_podcast,  portal_label_home,
      portal_label_wifigratis, show_popup, storeName, ghz_condition, fontParam, backgroundParam, fontColorParam
    } = this.state;
    //
    const { ap, deviceId, postBalance, userReg, location, test } = this.props;
    if (!campaigns.length) {
      return null;
    }
    if (errorMsg !== "") {
      return <p>{errorMsg}</p>;
    }
    const campaignPages = this._buildCampaignPages(campaigns);
    const campaignPage = campaignPages[campaignPageNumber].length > 0 && USER ? campaignPages[campaignPageNumber] : defaultCampaign ;
    const { passPortal } = this.props;

    const dealItems = campaignPage.map(campaign =>  (
     <div className="pt-2 pb-1" key={campaign.CampaignID} >
       
        {
          campaign.newsID ? <NewBanner
          campaign={campaign} 
          ap={ap} 
          test={test}
          passPortal={passPortal}
          deviceId={deviceId} 
          band={band} 
          survey_ids={survey_ids} 
          search={this.props.location.search} 
          token={token} 
          user={userReg}
          userData={USER}
          threshold={threshold}
          skip_seconds={skip_seconds}
          each_seconds={each_seconds}
          bc_seconds={bc_seconds}
          gads_seconds={gads_seconds}
          location={location}
          portal_label_return={portal_label_return}
          portal_show_timer={portal_show_timer}
          portal_label_access={portal_label_access}
          postBalance={(c, it, ids) => postBalance(c, it, ids)}
          start_counter={start_counter}
          forward_audio_podcast={forward_audio_podcast}
          show_popup={show_popup}
          ghz_condition={ghz_condition}
          backgroundParam={backgroundParam}
          fontColorParam={fontColorParam}
          fontParam={fontParam}
      /> : (
        <DealItem 
          campaign={campaign} 
          ap={ap} 
          test={test}
          passPortal={passPortal}
          deviceId={deviceId} 
          band={band} 
          survey_ids={survey_ids} 
          search={this.props.location.search} 
          token={token} 
          user={userReg}
          userData={USER}
          threshold={threshold}
          skip_seconds={skip_seconds}
          skip_podcast={skip_podcast}
          each_seconds={each_seconds}
          portal_label_return={portal_label_return}
          portal_show_timer={portal_show_timer}
          portal_label_access={portal_label_access}
          location={location}
          start_counter={start_counter}
          forward_audio_podcast={forward_audio_podcast}
          show_popup={show_popup}
          ghz_condition={ghz_condition}
          backgroundParam={backgroundParam}
          fontColorParam={fontColorParam}
          fontParam={fontParam}
          postBalance={(c, it, ids) => postBalance(c, it, ids)} />
      )
        }
      </div>
    )
    );
    
    this._capturePageImpression(campaignPage);
    return (
      <>

      <style jsx global>{`
          body {
              background: ${backgroundParam ? backgroundParam : ''};
              font-family: ${fontParam ? fontParam : 'system-ui'};
          }
      `}</style>
        <div
          className="list-group nigga"
          style={{
            flex: 1,
            maxWidth: "750px",
          }}
        >
          {
            (this.state.isCampaignLoading) ? <Loading /> : <>
            {
            logoURL && <img
            style={{
              maxWidth: "700px",
              margin: "0 auto",
              width: "80%",
              maxHeight: "100px",
              marginTop: "10px",
              marginBottom: "10px",
              aspectRatio: '16 / 9',
            }}
            src={`/google-storage/${encodeURIComponent(
              logoURL
            )}`}
          />
          }

          {
            (rtb.length && rtb[0].full_page) ? <RTBVideo rtb={rtb[0]} show_popup={show_popup}
            passPortal={passPortal} ap={ap} DeviceID={deviceId} postBalance={(c, it, ids) => postBalance(c, it, ids)}
            /> : (rtb.length && rtb[0].videourl) ? 
            <RTBVideoBanner 
                rtb={rtb[0]}
                ap={ap} 
                test={test}
                show_popup={show_popup}
                passPortal={passPortal}
                deviceId={deviceId} 
                band={band} 
                survey_ids={survey_ids} 
                search={this.props.location.search} 
                userData={USER}
                threshold={threshold}
                skip_seconds={skip_seconds}
                each_seconds={each_seconds}
                portal_label_return={portal_label_return}
                portal_show_timer={portal_show_timer}
                portal_label_access={portal_label_access}
                location={location}
                start_counter={start_counter}
                backgroundParam={backgroundParam}
                fontColorParam={fontColorParam}
                fontParam={fontParam}
                forward_audio_podcast={forward_audio_podcast}
                postBalance={(c, it, ids) => postBalance(c, it, ids)}
            
            /> : (
              <>
                <h5
                  style={{
                    textAlign: "center",
                    marginBottom: "20px",
                    color: fontColorParam ? fontColorParam : "#DD4641"
                  }}
                >
                  {portal_label_wifigratis ? portal_label_wifigratis +" " + storeName : `¡WiFi Gratis! ${wifiMinutes} Minutos`}
                </h5>
                <div
                  style={{
                    marginLeft: "20px",
                    marginRight: "20px"
                  }}
                >
                <div style={{
                  textAlign: "center"
                }}
                >
                </div>
                {
                  showAds.show && ( avisos && <HeaderAO test={test} avisos={avisos} bc_seconds={bc_seconds} label={showAds.label} itemURL={showAds.item_url}/>)
                }
                
                {
                  rtb.length ? rtb.map(r => <RTBBanner test={test} rtb={r} ap={ap} DeviceID={deviceId} passPortal={passPortal} /> )  : null
                }
              
                  {dealItems}
                </div>
                <h5
                  style={{
                    textAlign: "center",
                    marginTop: "20px",
                    color: fontColorParam ? fontColorParam : "#DD4641"
                  }}
                >
                {portal_label_home ? portal_label_home : "¡Dale click a una promoción para WiFi!"} 
                </h5>
                <FooterNav
                  maxCampaigns={defaults.maxCampaigns}
                  campaignsLength={campaigns.length}
                  campaignPageNumber={campaignPageNumber}
                  changePage={this._changePage}
                />

              </>
            )
          }
            
            
            </>
          }
        

          
        </div>
      
      </>
    );
  };
}
